<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { computed, onMounted } from 'vue';
import { useStore } from 'vuex';
import { loalStorageGet } from '@/utils/common.js';
import useVersion from '@/hooks/useVersion';

export default {
  name: 'App',
  setup() {
    const store = useStore();
    useVersion();

    // 替代 mapGetters
    const userInfo = computed(() => store.getters['user/userInfo']);

    onMounted(() => {
      // 禁用右键菜单
      document.oncontextmenu = function (event) {
        event.returnValue = false;
        return false;
      };

      // 监听页面可见性变化
      window.addEventListener('visibilitychange', function () {
        console.log('visibilitychange', document.visibilityState);
        if (document.visibilityState === 'visible') {
          if (loalStorageGet('studentUuid') && userInfo.value.uuid !== loalStorageGet('studentUuid')) {
            store.dispatch('user/SET_USER');
          }
        }
      });
    });

    return {
      userInfo,
    };
  },
};
</script>
